const actions = {
  SEARCH_HOME_DELIVERY_ORDERS: 'SEARCH_HOME_DELIVERY_ORDERS',
  SEARCH_HOME_DELIVERY_ORDERS_ENDED: 'SEARCH_HOME_DELIVERY_ORDERS_ENDED',
  FIND_HOME_DELIVERY_ORDER: 'FIND_HOME_DELIVERY_ORDER',
  FIND_HOME_DELIVERY_ORDER_ENDED: 'FIND_HOME_DELIVERY_ORDER_ENDED',
  UPDATE_HOME_DELIVERY_ORDER: 'UPDATE_HOME_DELIVERY_ORDER',
  UPDATE_HOME_DELIVERY_ORDER_END: 'UPDATE_HOME_DELIVERY_ORDER_END',
  BATCH_UPDATE_HOME_DELIVERY_ORDER: 'BATCH_UPDATE_HOME_DELIVERY_ORDER',
  BATCH_UPDATE_HOME_DELIVERY_ORDER_END: 'BATCH_UPDATE_HOME_DELIVERY_ORDER_END',
};
export default actions;
